import script from "./FixedRb.vue?vue&type=script&setup=true&lang=ts"
export * from "./FixedRb.vue?vue&type=script&setup=true&lang=ts"

import "./FixedRb.vue?vue&type=style&index=0&id=46d90a4d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46d90a4d"]])

export default __exports__